export enum ConsoleStatus {
	HTTP = 'http_error',
	NET = 'network_error',
	SUCC = 'success',
	FRONTEND = 'frontend_error',
}

/**
 * Utility function for logging development messages to the console based on a specified status.
 * Logs messages only if debug mode is enabled in environment variables (`VITE_DEBUG_MODE`).
 */

export const consoleDev = (
	source: string,
	type: ConsoleStatus,
	error?: any
) => {
	// Only log in development mode, not in production
	const isDebugMode = import.meta.env.VITE_DEBUG_MODE === 'true';

	if (!isDebugMode) return;

	switch (type) {
		case ConsoleStatus.HTTP:
			console.error(`(${source}) HTTP Error: `, error);
			break;
		case ConsoleStatus.NET:
			console.error(`(${source}) Network Error: `, error);
			break;
		case ConsoleStatus.SUCC:
			console.log(`(${source}) Success`);
			break;
		case ConsoleStatus.FRONTEND:
			console.log(`(${source}) Frontend Error`);
			break;
	}
};
